export default "__VITE_ASSET__iI6H47M8__"